import {ChangeDetectionStrategy, Component, OnInit} from '@angular/core';
import {PropertyMappingModel} from 'web-shared';
import {BaseModalComponent, CONSTANTS} from "common-shared";
import {IWithSpecs, SpecLineModel} from "web-shared";
import {StateService} from "web-shared";
import {Subject} from "rxjs";

export interface IPropertyMappingEditorModal {
  title: string;
  context: IWithSpecs;
  sourceType: string;
  isChanged: boolean;
  readonly: boolean;
}

@Component({
  selector: 'mes-web-property-mapping-editor-modal',
  templateUrl: './property-mapping-editor-modal.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class PropertyMappingEditorModalComponent extends BaseModalComponent implements OnInit, IPropertyMappingEditorModal {
  title = '';
  inheritedPropertyMappings: PropertyMappingModel[] = [];
  propertyMappings: PropertyMappingModel[];
  sourceType: string;
  showPropertyLocalizations: boolean = false;
  localizationEnabled: boolean = true;
  isChanged: boolean = false;
  wasValidated$: Subject<boolean> = new Subject<boolean>();
  readonly: boolean = false;
  context: IWithSpecs;

  constructor(private stateService: StateService) {
    super();
  }

  ngOnInit() {
    this.stateService.settings$.subscribe(value => this.localizationEnabled = value.Property.Localization);
  }

  change() {
    this.wasValidated$.next(true);
    if (this.context.Specs.every(spec => spec.isValid())) {
      this.close();
    }
  }

  onPropertyMappingAdded($event: PropertyMappingModel) {
    $event.MandatoryClv = CONSTANTS.Mandatory.Hidden;
  }

  onPropertyMappingRemoved($event: PropertyMappingModel) {
    this.propertyMappings = this.propertyMappings.filter(value => value.Id !== $event.Id);
  }

  onPropertyMappingChanged($event: PropertyMappingModel[]) {
    this.propertyMappings = [...$event];
  }
}
